// extracted by mini-css-extract-plugin
export default {"dashboard":"UserDashboard_dashboard__2NQM8","content":"UserDashboard_content__fwqnZ","userImage":"UserDashboard_userImage__yAXnB"};